import { APIUser, User } from 'libs/api'

// Websocket notification data is not transformed:
export const getUsername = (user: User | APIUser) => ('userName' in user ? user.userName : user.Username)
